// GẮN "TỪ KHOÁ NHIỀU DÒNG" VÀO KHỐI TÌM (06/10/2026) — xem src/shared/tu-khoa-nhieu-dong.ts (định dạng lưu, chế độ, chọn theo giờ).
import type { KhoiMau, KhoiThamSo } from "./tu-dung";
import { tenCauHinhTuKhoa } from "./tu-khoa-nhieu-dong";

export const TS_TU_KHOA_CAU_HINH = "tu_khoa_cau_hinh";
/** Khối TÌM có ô "Từ khoá" kiểu nhiều dòng + cấu hình (số lượng / giờ / chế độ). Khoá "<mạng>/<khối>". Reddit "tìm rồi bình luận" CHỈ xoay `a | b | c` theo lần chạy (từ khoá nằm trong địa chỉ tìm đã lắp) — không có số lượng / giờ. */
export const KHOI_CO_TU_KHOA_CAU_HINH: ReadonlySet<string> = new Set(["facebook/tim_bai", "facebook/tim_nhom", "tiktok/tim_video", "youtube/tim_video", "x/tim_bai", "reddit/tim_bai"]);

export const TS_CAU_HINH_TU_KHOA: KhoiThamSo = {
  ten: TS_TU_KHOA_CAU_HINH, kieu: "chuoi", anKhiRong: true,
  moTa: "cấu hình nhiều từ khoá (số lượng mỗi từ khoá, số giờ chuyển từ khoá, chế độ xoay) — trang soạn tự ghi, dạng “gio;2:24,1:48”; bỏ trống = xoay theo lần chạy như cũ",
};

/**
 * Gắn cấu hình nhiều từ khoá vào khối TÌM: + tham số `tu_khoa_cau_hinh`, + tham số kịch bản `<tham số từ khoá>_cau_hinh`, + dấu `ds_tu_khoa` ở bước LẤY DANH SÁCH
 * (bước extract ngay sau bước tìm; trỏ tới tham số từ khoá + bước tìm) để runner biết danh sách nào ứng với từ khoá nào (áp "số lượng", chế độ "tất cả").
 * Tự dò bước tìm (bước chứa {{<tham số từ khoá>}}) và bước lấy (extract đầu tiên sau đó). Khối đã gắn → trả nguyên khối; không dò được → ném lỗi (lỗi thư viện, test bắt).
 */
export function themTuKhoaNhieuDong(k: KhoiMau): KhoiMau {
  if (k.thamSo.some((t) => t.ten === TS_TU_KHOA_CAU_HINH)) return k;
  const pn = Object.entries(k.params ?? {}).find(([, p]) => p.default === "{{ts.tu_khoa}}")?.[0];
  if (!pn) throw new Error(`khối '${k.ten}': không có tham số kịch bản lấy từ ô tu_khoa`);
  const chunks = k.yamlSteps.split(/^(?=\s*- id:)/m).filter((c) => /- id:/.test(c));
  const iTim = chunks.findIndex((c) => c.includes(`{{${pn}}}`));
  const lay = iTim < 0 ? undefined : chunks.slice(iTim + 1).find((c) => /^\s+extract:/m.test(c) && /^\s+into:/m.test(c));
  const tim = iTim < 0 ? undefined : /- id:\s*([A-Za-z0-9_]+)/.exec(chunks[iTim]!)?.[1];
  const layId = lay ? /- id:\s*([A-Za-z0-9_]+)/.exec(lay)?.[1] : undefined;
  if (!tim || !layId) throw new Error(`khối '${k.ten}': không dò được bước tìm / bước lấy danh sách để gắn cấu hình nhiều từ khoá`);
  return {
    ...k,
    thamSo: [...k.thamSo, TS_CAU_HINH_TU_KHOA],
    params: { ...(k.params ?? {}), [tenCauHinhTuKhoa(pn)]: { type: "string", default: `{{ts.${TS_TU_KHOA_CAU_HINH}}}`, label: `Cấu hình nhiều từ khoá (${pn})` } },
    learned: { ...k.learned, [layId]: { ...((k.learned[layId] ?? {}) as Record<string, unknown>), ds_tu_khoa: { param: pn, tim } } },
  };
}
export function themTuKhoaNhieuDongChoMang(ma: string, ds: KhoiMau[]): KhoiMau[] {
  return ds.map((k) => (KHOI_CO_TU_KHOA_CAU_HINH.has(`${ma}/${k.ten}`) ? themTuKhoaNhieuDong(k) : k));
}
/** Lúc LẮP: bỏ dấu `ds_tu_khoa` khỏi phần đã học khi không có cấu hình → bundle y như trước (hash không đổi, plugin cũ chạy như cũ). */
export function locTuKhoaLearned<T>(learned: T, bat: boolean): T {
  if (bat) return learned;
  const loc = (v: unknown): unknown => {
    if (Array.isArray(v)) return v.map(loc);
    if (!v || typeof v !== "object") return v;
    const out: Record<string, unknown> = {};
    for (const [k, x] of Object.entries(v as Record<string, unknown>)) {
      if (k === "ds_tu_khoa" && x && typeof x === "object" && "param" in x && "tim" in x) continue;
      out[k] = loc(x);
    }
    return out;
  };
  return loc(learned) as T;
}
